import React from 'react';
import styles from './Footer.module.css';

/**
 * フッターコンポーネント
 * @param {object} props
 * @param {Array<{href: string, icon: string, label: string}>} props.socialLinks - SNSリンクリスト
 * @param {string} props.copyrightText - コピーライト表示テキスト
 */
const Footer = ({ socialLinks = [], copyrightText = '© 2025 Your Name' }) => {
  const getSocialIconClass = (url) => {
    if (url.includes('x.com')) return 'fa-brands fa-x-twitter'; // X用のアイコンクラス
    if (url.includes('youtube.com')) return 'fab fa-youtube';
    if (url.includes('instagram.com')) return 'fab fa-instagram';
    if (url.includes('twitch.tv')) return 'fab fa-twitch';
    return ''; // 一致しない場合は空文字列
  };

  return (
    <footer id="footer" className={styles.footer}>
      <div className={styles.socialLinks}>
        {socialLinks.map(link => (
          <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label={link.label}>
            <i className={getSocialIconClass(link.href)}></i> {/* Font Awesomeアイコンを表示 */}
          </a>
        ))}
      </div>
      <p className={styles.copyright}>{copyrightText}</p>
    </footer>
  );
};

export default Footer; 